import { not } from 'ramda';
import ButtonContainer from '@@viewCommonComponents/forms/ButtonContainer';
import { FormProvider } from 'react-hook-form';
import FilesUploadContainer from './components/FilesUploadContainer';
import useSouscriptionSupportingDocumentsForm from './hooks/useSouscriptionSupportingDocumentsForm';
import ElectronicSignatureStarted from './components/ElectronicSignatureStarted';
import ManualSignatureCompleted from './components/ManualSignatureCompleted';
import { PageLayout } from '@@viewCommonComponents/forms/Layouts.jsx';
import { Icon, PageSubtitle, PageTitle } from '@fasstech/middle-design-system';
import ErrorOnSendForSignatureModal from './components/ErrorOnSendForSignatureModal';
import ErrorOnSaveDocumentsModal from '@@viewCommonComponents/displayer/ErrorOnSaveDocumentsModal';
import { isNotNilOrEmpty } from '@@serverHelpers';

const SouscriptionSupportingDocumentsForm = ({
  data,
  getMiddleText,
  middleFeatures,
  context,
  processHandlers
}) => {
  const {
    form,
    $onPrevClick,
    onSubmit,
    deleteDocuments,
    documents,
    maxFileSize,
    uploadedFileLimit,
    loading,
    signatureStarted,
    isElectronicSignature,
    errorSendForSignatureModalMessage,
    setErrorSendForSignatureModalMessage,
    errorSaveDocumentModalMessage,
    setErrorSaveDocumentModalMessage,
    isValid
  } = useSouscriptionSupportingDocumentsForm({
    data,
    context,
    processHandlers
  });

  if (signatureStarted && isElectronicSignature) {
    return (
      <ElectronicSignatureStarted getMiddleText={getMiddleText} middleFeatures={middleFeatures} />
    );
  } else if (signatureStarted && not(isElectronicSignature)) {
    return <ManualSignatureCompleted getMiddleText={getMiddleText} />;
  }

  return (
    <>
      <PageLayout withFormLayout={false} className={'flex flex-col gap-4 items-center'}>
        <Icon name="circleFile" size={70} />
        <PageTitle>{getMiddleText('ENVOI_PIECES_JUSTIF_VIEW_TITLE')}</PageTitle>
        <PageSubtitle>{getMiddleText('ACCEPTED_FILE_FORMAT_LABEL')}</PageSubtitle>
        <FormProvider {...form}>
          <FilesUploadContainer
            documents={documents}
            form={form}
            getMiddleText={getMiddleText}
            deleteDocuments={deleteDocuments}
            maxFileSize={maxFileSize}
            uploadedFileLimit={uploadedFileLimit}
          />
        </FormProvider>
      </PageLayout>
      <ButtonContainer
        $onPreviousButtonClick={$onPrevClick}
        $onNextButtonClick={form.handleSubmit((data) => onSubmit(data, false))}
        nextButtonIsDisabled={not(isValid)}
        nextButtonIsLoading={loading}
        getMiddleText={getMiddleText}
        nextButtonLabel={
          isElectronicSignature
            ? getMiddleText('NEXT_BUTTON_ELECTRONIC')
            : getMiddleText('NEXT_BUTTON_MANUAL')
        }
        isFormError={not(isValid)}
        displayResumeButton
      />

      <ErrorOnSendForSignatureModal
        isDisplayed={isNotNilOrEmpty(errorSendForSignatureModalMessage)}
        errorSendForSignatureModalMessage={errorSendForSignatureModalMessage}
        setErrorSendForSignatureModalMessage={setErrorSendForSignatureModalMessage}
      />

      <ErrorOnSaveDocumentsModal
        isDisplayed={isNotNilOrEmpty(errorSaveDocumentModalMessage)}
        errorSaveDocumentModalMessage={errorSaveDocumentModalMessage}
        setErrorSaveDocumentModalMessage={setErrorSaveDocumentModalMessage}
        onClick1={form.handleSubmit((data) => onSubmit(data, true))}
        button1Label={
          isElectronicSignature
            ? getMiddleText('NEXT_BUTTON_ELECTRONIC')
            : getMiddleText('NEXT_BUTTON_MANUAL')
        }
      />
    </>
  );
};

export default SouscriptionSupportingDocumentsForm;
